import React, { Component } from "react";
import { I18n } from "react-redux-i18n";
import { connect } from "react-redux";
import admin, { getMenuItem, getPriceForQuantity } from "../../js/admin";
import "./customerScreen.css"
import auth from "../../js/auth";
import { stopIntervals } from "../../js/point-of-sale";
import TipPicker from "../../components/tipPicker";
import { get } from "jquery";

const tipTimeout = 150000; //10 seconds

class CustomerScreen extends Component {

    state = {
        ... (sessionStorage.customerScreenData ? JSON.parse(sessionStorage.customerScreenData) : {

            orders: [],
            index: 0,
        }),
        tip: 0,
        channel: null,
        initialized: false,
        askForTip: false
    };

    componentDidUpdate = () => {
        if (auth?.device?.platform === "Android") {
        }

    }

    handler = (event) => {

        const data = event?.data?.data || event?.detail?.data?.data;
        const images = event?.data?.images || event?.detail?.data?.images || [];
        const type = event?.data?.type || event?.data?.data?.type || event?.detail?.data?.type;
        if (!type) {
            return;
        }
        if (data && type === "check") {
            this.sendMessage({ check: "ready" });
        } else if (type === "askForTip") {
            this.setState({ askForTip: true, tipSelected: false, tip: 0 });
        } else if (type === "cancelAskForTip") {
            this.setState({ askForTip: false, tipSelected: false });
        } else if (type === "thanks") {
            this.setState({ askForTip: true, tipSelected: true });
        } else if (type === "update") {
            //this.setState({ tipSelected: false });
            if (event?.data?.tip !== undefined) {
                this.setState({ tip: event?.data?.tip });
            }
            if (data) {
                if (data?.length === 0) {
                    this.setState({ tip: 0, askForTip: false, tipSelected: false });
                }
                this.setState({ orders: data, /*askForTip: false, tipSelected: false,*/ images: images, index: Math.min(this.state.index, images?.length) });
            } 
            setTimeout(() => {
                this.sendMessage({ check: "ready" });
            }, 500);
        }
        this.sendMessage({ check: "ok" });
        localStorage.setItem("msg", JSON.stringify({ check: "ok", timestamp: new Date().getTime() }));
        return;
    }


    componentDidMount = () => {

        if (this?.state?.channel) return;
        const channel = new BroadcastChannel('customerScreen');

        this.setState({ channel: channel });

        channel.onmessage = this.handler;
        /* this is working */
        document.addEventListener("message", this.handler);

        if (navigator?.presentation?.onpresent) {
            navigator.presentation.onpresent = function (event) {
                alert("Presentation session started on customer screen");
                if (event.session) {
                    alert("Customer screen presentation session established, setting up message handler");
                    const session = event.session;
                    session.onmessage = (msg) => {
                        alert("Customer screen received message " + JSON.stringify(msg));
                        this.handler(msg);
                    };
                }
            };
        } else {
        }

        this.interval = setInterval(this.nextPicture, 3000);

        admin.getActiveMenuItems(data => {
            admin.categories = data;
            this.setState({ initialized: true });
        })
    }

    componentWillUnmount = () => {
        stopIntervals(this.interval);
    }

    nextPicture = () => {
        if (this?.state?.channel)
            this.sendMessage({ source: this.props.match.params.tableNumber, check: "ready" });

        if (this.state.images)
            this.setState({ index: this.state.index < this.state.images.length - 1 ? this.state.index + 1 : 0 })
    }

    sendMessage = (message) => {
        try {
            if (sessionStorage.customerScreen && sessionStorage.customerScreen !== "null") {
                message.CustomerScreen = sessionStorage.customerScreen;
                message.Restaurant = localStorage.restaurantSelected;
                auth.sendMessage2(message);
            } else {
                this.state.channel.postMessage(message, window.location.href);
            }
        } catch (e) {
            this.state.channel.postMessage(message, window.location.href);
        }
    }

    render() {
        sessionStorage.customerScreenData = JSON.stringify(this.state);

        if (!this.props.myStatus.restaurant_base_currency || !admin.categories || !this.state.initialized)
            return null;

        if (this.state.askForTip && !this.state.tipSelected) {
            if (this.tipTimeout) clearTimeout(this.tipTimeout);
            this.tipTimeout = setTimeout(() => {
                clearTimeout(this.tipTimeout);
                if (this.state.askForTip && !this.state.tipSelected) {
                    this.setState({ tipSelected: true }, () => {
                        this.sendMessage({ type: "tipSelected", tip: 0 });
                    });
                }
                //   this.setState({ askForTip: true, tipSelected: true, tip: 0 });
            }, tipTimeout);
        } else {
            if (this.tipTimeout) clearTimeout(this.tipTimeout);
        }

        if (this.state.orders && this.state.orders.length === undefined) {
            return null;
        }

        const totalPrice = this.state.orders ? this.state.orders.reduce((a, b) => a + b.price, 0) : 0;

        return (
            <div className="customerScreen" key="0">
                <div className="orderLevel1" key="1">
                    {this.state?.orders?.map && this.state.orders.map((order, ind) =>
                        <React.Fragment>
                            {order.orders && order.orders.map((order, ind1) =>
                                order.orders.map((order, ind2) =>
                                    <React.Fragment>
                                        <div key={order.orderIds + ".1"} className="count">{order.orderCount}  x&nbsp;</div>
                                        <div key={order.orderIds + ".2"} className="name">{order.menuItem.name} {this.getQuantity(order)}</div>
                                        <div key={order.orderIds + ".3"} className="unitPrice">{getPriceForQuantity(getMenuItem(order.menuItem.id), order.quantity)}</div>
                                        <div key={order.orderIds + ".4"} className="price">{order.orderCount * order.price} {this.props.myStatus.restaurant_base_currency.name}</div>
                                        {order.childOrders.map((childOrder, ind3) =>
                                            <React.Fragment>
                                                <div key={order.orderIds + "." + ind3 + ".1"}></div>
                                                <div key={order.orderIds + "." + ind3 + ".2"} className="childName">{childOrder.menuItem.name} {this.getQuantity(childOrder)}</div>
                                                <div key={order.orderIds + "." + ind3 + ".3"} className="childPrice">{(childOrder.addition ? 1 : -1) * childOrder.fullPrice}</div>
                                                <div key={order.orderIds + "." + ind3 + ".4"}></div>
                                            </React.Fragment>
                                        )}
                                    </React.Fragment>
                                )
                            )}
                        </React.Fragment>
                    )}
                    <div key="8" className="count footer">{I18n.t("admin_local.Total price").split('<br/>').map((line, index) => (
                        <React.Fragment key={index}>
                            <div>{line}</div>
                        </React.Fragment>
                    ))}</div>
                    <div key="9" className="price footer">{auth.round(totalPrice)} {this.props.myStatus.restaurant_base_currency.name}</div>
                    {this.props.myStatus.restaurant_currencies.filter(c => c.isActive).map(currency =>
                    (
                        <>
                            <div key={currency.id} className="count footer"></div>
                            <div key={currency.id} className="price footer">{this.applyRoundFunction(currency.currency.javaScriptRoundFunction, this.state.orders.reduce((a, b) => a + b.price / currency.exchangeRate, 0))} {currency.currency.name}</div>
                        </>
                    )
                    )}
                    {this.state.tip > 0 &&
                        (
                            <>
                                <div key="6" className="count footer">{I18n.t("admin_local.Total tip").split('<br/>').map((line, index) => (
                                    <React.Fragment key={index}>
                                        <div>{line}</div>
                                    </React.Fragment>
                                ))}</div>
                                <div key="7" className="price footer">{auth.round(this.state.tip)} {this.props.myStatus.restaurant_base_currency.name}</div>

                                <div key="10" className="count footer">{I18n.t("admin_local.amount_with_tip").split('<br/>').map((line, index) => (
                                    <React.Fragment key={index}>
                                        <div>{line}</div>
                                    </React.Fragment>
                                ))}</div>
                                <div key="11" className="price footer">{auth.round(totalPrice + this.state.tip)} {this.props.myStatus.restaurant_base_currency.name}</div>

                            </>
                        )
                    }
                    <div className="logo" key="logo">
                        <div className="logo2"></div>
                    </div>
                </div>
                <div className="ads" key="2">
                    {this.state.askForTip &&
                        (< TipPicker myStatus={this.props.myStatus} basePrice={totalPrice} thanks={this.state.askForTip && this.state.tipSelected} onTipSelected={(tip) => {
                            if (this.state.tipSelected) return;
                        this.setState({ tipSelected: true, tip: auth.round((totalPrice * tip) / 100) }, () => {
                            console.log("Tip selected: " + tip);
                            this.sendMessage({ type: "tipSelected", tip: tip });
                            });
                        }} >
                        </TipPicker>)}
                    <div className="ads-img">
                        {this.state.images && this.state.images.length > 0 ?
                            <img alt="" src={auth.server + "/" + auth.war + "/adminService/" + localStorage.restaurantSelected + "/getImage/" + this.state.images[this.state.index]}></img>
                            : null}
                    </div>
                </div>
            </div >)
    }

    applyRoundFunction = (roundFunctionStr, amount) => {
        try {
            if (!roundFunctionStr || roundFunctionStr.trim() === "") {
                return auth.round(amount);
            }
            // Replace 'amount' in the string with the actual numeric value
            const expression = roundFunctionStr.replace(/amount/g, amount);
            // Evaluate safely using Function constructor
            return Function(`"use strict"; return (${expression});`)();
        } catch (e) {
            console.warn("Invalid rounding function, defaulting to Math.round");
            return amount;
        }
    }


    getQuantity = (o) => {
        var menuItem = getMenuItem(o.menuItem.id);
        var quantityType = o.quantityType ? o.quantityType : menuItem.quantityType;
        if (quantityType === "undefined" || quantityType === "" || quantityType === "none") return "";
        var quantityLabel = "";
        var quantity = o.quantity;
        menuItem.availableQuantities.forEach(function (q) {
            if (Math.abs(q.quantity) === Math.abs(quantity)) {
                quantityLabel = q.quantityType ? q.quantityType.name : q.name;
                if (quantityLabel === "N/A") quantityLabel = "";
            }
        });
        if (quantityLabel !== "" && menuItem.entityType === "Meal") {
            return (quantity < 0 ? quantity + " " : "") + quantityLabel;
        } else {
            var v = quantityLabel !== "" ? quantityLabel + " " : "";
            v += Math.abs(quantity) === 1 && quantityType === "pcs" ? "" : "(" + (quantity + (quantity === 1 && quantityType === "pcs" ? "" : quantityType === "" ? "" : " " + I18n.t("local." + quantityType))) + ")";
            return v;
        }
    }


}
const mapStateToProps = (props, state) => {
    if (props.rootReducer.myStatus) {
        return {
            restaurant: props.rootReducer.restaurant,
            myStatus: props.rootReducer.myStatus,
            admin_local: props.rootReducer.admin_local,
            local: props.rootReducer.local,
            speechRecognitionOn: props.rootReducer.speechRecognitionOn,
            ai: props.rootReducer.ai,
            speechRecognitionAvailable: props.rootReducer.speechRecognitionAvailable,
            tables: props.rootReducer.tables
        };
    }
    return {};
};

export default connect(mapStateToProps)(CustomerScreen);
